/**
 * Path segments that a URL resolver collapses rather than sends. Percent-
 * encoding does not neutralise them: `encodeURIComponent(".")` is `"."`, so a
 * dot segment survives encoding intact and is removed — along with the segment
 * before it, for `..` — while the URL is being normalised.
 */
const DOT_SEGMENTS = new Set([".", ".."]);
/**
 * Builds a request path from a `:param` template and the positional arguments
 * a generated method received.
 *
 * Path parameters are the one part of a request the SDK builds itself — query
 * and body are handed to `Client.fetch` untouched — so they are validated and
 * encoded here. An unencoded id containing `/` or `?` would otherwise silently
 * retarget the request at a different route.
 */
export const buildPath = (template, params) => {
    let index = 0;
    const path = template.replace(/:([A-Za-z0-9_]+)/g, (_match, name) => {
        const value = params[index];
        index += 1;
        if (typeof value !== "string" || value.length === 0) {
            throw new TypeError(`Missing path parameter "${name}" for "${template}"`);
        }
        // Rejected rather than encoded: `retrieve("..")` would otherwise resolve to
        // the parent collection and issue a request the caller never asked for.
        if (DOT_SEGMENTS.has(value)) {
            throw new TypeError(`Path parameter "${name}" for "${template}" must not be "${value}"`);
        }
        return encodeURIComponent(value);
    });
    if (index !== params.length) {
        throw new TypeError(`Expected ${index} path parameter(s) for "${template}", received ${params.length}`);
    }
    return path;
};
//# sourceMappingURL=path.js.map